import { render, staticRenderFns } from "./TreatyParam.vue?vue&type=template&id=3c1b9f63&"
import script from "./TreatyParam.vue?vue&type=script&lang=js&"
export * from "./TreatyParam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports